export default "__VITE_ASSET__Dtm64mZN__"